import * as net from 'util/Net';

import {FeedbackContextItem} from './LLMFeedbackConstants';

export function submitLLMFeedback(
  feature: string,
  feedback: string,
  context: Array<FeedbackContextItem>,
  score?: number | null
): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/llm/feedback',
    data: {
      feature,
      feedback,
      context,
      ...(score != null && {score}),
    },
  });
}
